
import ImgBanner from "@/assets/image/video-bg.png"
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png";
import OurImg from "@/assets/industry-co-led/banner/our-offering.png";
import MsuAdvantagesImg from "@/assets/industry-co-led/banner/MSU-advantages.png"
import addintionImg from '@/assets/industry-co-led/image/little-girl-checking-up-her-sight-ophthalmology-center.png'

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Img1 from "@/assets/industry-co-led/image/infrastructure-1.png";
// import Img2 from "@/assets/industry-co-led/image/infrastructure-2.png";
// import Img3 from "@/assets/industry-co-led/image/infrastructure-3.png";
// import Img4 from "@/assets/industry-co-led/image/infrastructure-4.png";
import Img5 from "@/assets/industry-co-led/image/infrastructure-5.png";
const Img2 = "https://cdn.msu.edu.in/EMT_9cdd1dfe2e.webp";
const Img3 = "https://cdn.msu.edu.in/emergency_medical_technology_5a1a2eb660.webp";
const Img4 = "https://cdn.msu.edu.in/EMT_4_1_1076f66f8c.png"
import OJLImg1 from "@/assets/industry-co-led/image/OJL-1.png";
import OJLImg2 from "@/assets/industry-co-led/image/OJL-2.png";
import OJLImg3 from "@/assets/industry-co-led/image/OJL-3.png";
import OJLImg4 from "@/assets/industry-co-led/image/OJL-4.png";
import OJLImg5 from "@/assets/industry-co-led/image/OJL-5.png";
import OJLImg6 from "@/assets/industry-co-led/image/OJL-6.png";

export const diplomaEMT = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Diploma in Emergency Medical Technology", url: "" }
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "Diploma in Emergency Medical Technology",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: REDVERSITY
        },
        duration: "2.5 Year Diploma Programme",
        description:
            "Learn about Introductory Physics, Introductory Chemistry, Introduction to Emergency Medical Services, Applied Patient Assessment and more.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Job-linked Programmes"
            }
        ],

        buttons: {
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://img.youtube.com/vi/luz7uMhFXUY/hqdefault.jpg',
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/luz7uMhFXUY?si=sJ4jQgQqaw-Wqma2"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "Diploma for Emergency Care Professionals",

        description: [
            "The Diploma in Emergency Medical Technology prepares students to respond to medical emergencies with confidence and precision. The programme combines foundational science with hands-on training in emergency care, patient assessment and life-saving procedures.",

            "Students gain practical exposure in ambulance services, emergency departments, and real-world healthcare settings, ensuring they are industry-ready from day one. With a strong focus on clinical skills, emergency response, and patient care, learners develop the expertise required to handle critical situations and support healthcare teams effectively."
        ],

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Job-linked Programmes"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 2.5 Year Journey",

        journey: [
            {
                "phase": "YEAR 1",
                "title": "Building Foundation & Clinical Awareness",
                "description": "Introductory Sciences, Human Anatomy, Physiology and more"
            },
            {
                "phase": "YEAR 2",
                "title": "Emergency Care & Specialisation",
                "description": "Emergency Medical Services, Neonatal, Paediatric, and Geriatric Emergency"
            },
            {
                "phase": "FINAL PHASE (OJL)",
                "title": "On-the-Job Learning & Clinical Training",
                "description": "Real-world training in hospitals, ambulances, and emergency units"
            },
            {
                "phase": "GRADUATE",
                "title": "Diploma in Emergency Medical Technology",
                "description": "Industry-ready healthcare professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Allied Healthcare Education"
        },


        description:
            "We offer a UGC-approved, diploma programme in Emergency Medical Technology. It is an industry-aligned allied healthcare degree designed to build strong skills and prepare students for diverse roles.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Introduction to Health Science",
                "Introduction to Emergency Medical Services",
                "Human Anatomy and Physiology",
                "Emergency Medical Services and Equipment",
                "Respiratory and Cardiac Emergency",
                "Elementary Nursing"
            ]
        },

        image: 'https://cdn.msu.edu.in/small_DSC_00373_1_532a10af8b_30eb3b8e25.jpg'
    },

    whyEMT: {
        tag: "WHY EMERGENCY MEDICAL TECHNOLOGY. WHY NOW.",
        title: "Meeting the Demand for Skilled Emergency Responders",
        description:
            "Our Diploma in Emergency Medical Technology aligns with industry trends, offering a comprehensive curriculum that balances theoretical knowledge with practical experience.",

        stats: [
            {
                value: "11%",
                text: "job growth in the allied-health workforce is projected by 2030",
            },
            {
                value: "2–3×",
                text: "more EMTs are required in India than currently available to meet WHO emergency response benchmarks",
            },
            {
                value: "1 Million+",
                text: "medical emergencies occur annually in India, highlighting the urgent need for trained emergency responders and pre-hospital care professionals.",
            },
        ],
    },
    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Redversity, Delivered at MSU Campus",
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training",
            },
        ],
        pointerTitle: "Highlights from The Programme:",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasonal medical professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to ‘learn and earn’ through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
        ],

        image: 'https://cdn.msu.edu.in/large_EMT_ba4b512f42.jpg',
    },
    CTA: {
        title: "Start Your Journey in EMT with Redversity’s",
        highlights: "Diploma in Emergency Medical Technology",
        url: "#",
        btnName: "Apply Now"
    },
    onJobtrainningData: {
        tag: "Hands-On Experience",
        title: "On-the-Job Learning",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            { "id": 1, "src": OJLImg1, "alt": "Medical training" },
            { "id": 2, "src": OJLImg2, "alt": "Lab practice" },
            { "id": 3, "src": OJLImg3, "alt": "Patient training" },
            { "id": 4, "src": OJLImg4, "alt": "Lab testing" },
            { "id": 5, "src": OJLImg5, "alt": "Computer lab work" },
            { "id": 6, "src": OJLImg6, "alt": "Chemical lab testing" }
        ]
    },
    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "Bonus Credentials",
                "title": "Additional Skills Certifications",
                "description": "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Advanced Cardiovascular Life Support (ACLS), Basic Trauma Life Support (BTLS) and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
                "image": {
                    "url": 'https://cdn.msu.edu.in/EMT_3_982c53f301.jpg',
                    "alternativeText": "Skill Certification"
                },
                "items": [
                    {
                        "id": 1,
                        "text": "BLS, ACLS & BTLS Certified",
                        "icon": Icon1
                    },
                    {
                        "id": 2,
                        "text": "Nationally & Globally Recognised",
                        "icon": Icon2
                    }
                ],
                "button": {
                    "text": "Apply Now",
                    "link": "/apply"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            { id: 1, src: Img1, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 2, src: Img2, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 3, src: Img3, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 4, src: Img4, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 5, src: Img5, size: "small", alt: "Do-Experience-Learn-lab" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
        students: [

            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Eligibility",
        description:
            "10+2 (Any Stream) with 50% Aggregate",
        button: {
            text: 'Apply Now',
            url: ""
        },
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "Join this Diploma in Emergency Medical Technology programme and embark on a rewarding journey in the heart of the healthcare industry",
        "roles": [
            "Emergency Medical Technician (EMT)/Paramedic",
            "Trauma Care Specialist/Critical Care Assistant",
            "Ambulance Services Coordinator/Field Responder",
            "Hospital Emergency Department Technician/ER Support Staff",
            "Patient Transport and Monitoring Officer",
            "First Responder/Disaster Response Technician",
            "Medical Equipment and Life Support Technician",
            "Community Health and Emergency Services Officer",
            "Fire and Rescue Emergency Technician",
            "Occupational Health and Safety Assistant",
            "Clinical Support Staff/Health Services Assistant",
            "Adventure & Remote Area Medical Technician",
            "Health & Safety Trainer/CPR Instructor",
            "Entrepreneur (Private Ambulance Services/Emergency Care Consultancy)"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building the Foundation",
                "description": "This semester introduces students to the fundamental sciences, communication skills and personal effectiveness required for a career in health and emergency medical services. The focus is on building a strong academic base, understanding basic human biology and developing discipline, confidence and professional behavior.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "English & Communication – Essential Skills", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Introductory Physics (C+P)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Introductory Chemistry (C+P)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Introductory Biology (C+P)", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Introduction to Health Science", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Personal Effectiveness", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Skill Drill – I", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 1 (Curricular Activities, Personality Dev, Ambulance Ride-along Orientation, Live Project I)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Build foundational knowledge in physics, chemistry and biology",
                    "Develop essential English and professional communication skills",
                    "Understand the basics of health science and human biology",
                    "Build personal effectiveness and professional behaviour",
                    "Gain initial ambulance and live project exposure"
                ]
            },
            {
                "name": "Semester 2",
                "title": "From Basics to Clinical Awareness",
                "description": "This semester strengthens communication skills while introducing students to digital tools, emergency medical services, human anatomy and biochemistry. This semester bridges theory with applied learning, preparing students for patient interaction and basic clinical responsibilities.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "English & Communication – Advanced Skills", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Fundamentals of Digital Applications", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Introduction to Emergency Medical Services (C+P)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Patient Assessment & Medication Administration", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Human Anatomy and Physiology (C+P)", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "General Biochemistry (C+P)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Interpersonal Effectiveness", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Skill Drill – II", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Holistic Development Module 2 (Curricular, Personality Dev, Ambulance Ride-along II, Live Project II)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Strengthen advanced communication and digital skills",
                    "Understand the fundamentals of emergency medical services",
                    "Perform basic patient assessment and medication administration",
                    "Apply knowledge of human anatomy, physiology and biochemistry",
                    "Develop interpersonal effectiveness for patient interaction"
                ]
            },
            {
                "name": "Semester 3",
                "title": "Advanced Emergency Care",
                "description": "In this semester, the focus begins on managing trauma, respiratory and cardiac emergencies. Students gain hands-on experience with emergency equipment, pharmacology basics and real-world healthcare challenges while preparing for professional career pathways.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Trauma Emergency and Lifting, Moving (C+P)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Respiratory and Cardiac Emergency (C+P)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Emergency Medical Services and Equipment", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "General Pharmacology", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Science and the World", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Career Readiness", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Skill Drill – III", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 3 (Curricular, Personality Dev, Ambulance Ride-along III, Live Project III)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Manage trauma emergencies including lifting and moving patients",
                    "Handle respiratory and cardiac emergency situations",
                    "Operate emergency medical equipment effectively",
                    "Apply general pharmacology knowledge in the field",
                    "Prepare professionally for healthcare career pathways"
                ]
            },
            {
                "name": "Semester 4",
                "title": "Clinical Practice and Specialisation",
                "description": "The last phase emphasizes specialized emergency care and real-world clinical practice. Students gain exposure to obstetric, pediatric, neurological and geriatric emergencies while applying nursing skills in supervised clinical settings.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Obstetrics and Gynaecology Emergency (C+P)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Neonatal, Paediatric & Geriatric Emergency", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Neurological and Endocrine Emergency (C+P)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Renal and Genitourinary Emergency", "bgColor": "bg-[#E8D4FF]", "textColor": "text-[#7B2CBF]" },
                    { "name": "Psychology", "bgColor": "bg-[#FFD4E5]", "textColor": "text-[#C41E3A]" },
                    { "name": "Elementary Nursing", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Clinical Practice DEMT – 1", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Holistic Development Module 4 (Curricular, Personality Dev, Ambulance Ride-along IV, Live Project IV)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ],
                "learningOutcomes": [
                    "Manage obstetric, gynaecological and neonatal emergencies",
                    "Handle paediatric, geriatric and neurological emergencies",
                    "Apply renal and endocrine emergency response protocols",
                    "Practice elementary nursing skills in supervised clinical settings",
                    "Build psychological awareness for patient and team care"
                ]
            },
            {
                "name": "Semester 5",
                "title": "Industry Immersion (On-the-Job Learning)",
                "description": "This phase focuses on real-world industry exposure, where students step into active healthcare environments while continuing their studies. Through this hands-on experience, students build confidence, understand workplace dynamics, and develop job-ready competencies.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    { "name": "Clinical Internship / OJT at Red.Health Network", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Internship Portfolio, Viva & HDSIM 5 – Internship Intensive (CV, Reflection, Live Project Capstone)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ],
                "learningOutcomes": [
                    "Gain hands-on clinical experience at Red.Health Network",
                    "Build confidence and job-ready competencies in real healthcare environments",
                    "Understand workplace dynamics in emergency medical services",
                    "Complete internship portfolio and viva assessment",
                    "Finalise career readiness through CV and live project capstone"
                ]
            },
            {
                "name": "Value Addition",
                "title": "Value-Added Learning Opportunities",
                "description": "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",

                "subjects": [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq:
    {
        id: 101,
        title: "Find quick answers to the most common questions about our programme",
        FAQ: [
            {
                "id": 1,
                "Question": "What does the Diploma in Emergency Medical Technology cover?",
                "Answer": "The Diploma in Emergency Medical Technology covers critical skills for emergency care, including patient assessment, trauma management, basic life support, first aid, ambulance operations and medical equipment handling. It combines hands-on training with theoretical knowledge to prepare students for careers as competent emergency medical technicians."
            },
            {
                "id": 2,
                "Question": "What is a Diploma in Emergency Medical Technology (EMT)?",
                "Answer": "A Diploma in Emergency Medical Technology (EMT) is a skill-based programme that trains students to provide immediate medical care in emergency situations. It focuses on developing the practical and clinical expertise required by emergency medical technicians to handle critical cases efficiently."
            },
            {
                "id": 3,
                "Question": "What is the duration of the EMT course at MSU?",
                "Answer": "The Diploma in Emergency Medical Technology at MSU is a 2.5-year programme designed to provide both theoretical knowledge and hands-on training."
            },
            {
                "id": 4,
                "Question": "What are the eligibility criteria to enroll in this Diploma in Emergency Medical Technology?",
                "Answer": "Completion of 10+2 (Class 12th) from a recognized board."
            },
            {
                "id": 5,
                "Question": "What skills will students gain during the EMT course?",
                "Answer": "Students will develop essential skills such as patient assessment, emergency response, trauma handling, basic life support, communication in critical situations and efficient use of medical equipment, key competencies required for emergency medical technicians."
            },
            {
                "id": 6,
                "Question": "What job roles can you expect after completing a Diploma in Emergency Medical Technology?",
                "Answer": "After completing a Diploma in Emergency Medical Technology, you can work as an Emergency Medical Technician (EMT), trauma care specialist, ambulance responder, hospital ER technician, patient transport officer, disaster response technician, medical equipment assistant or even start your own emergency care services.",

            },
            {
                "id": 7,
                "Question": "What is the average salary after this diploma?",
                "Answer": "The average salary after completing a Diploma in Emergency Medical Technology can vary based on experience and location, with growth opportunities as experience increases.",

            },
            {
                "id": 8,
                "Question": "Why choose a Diploma in Emergency Medical Technology at MSU?",
                "Answer": "MSU offers a hands-on, industry-aligned Diploma in Emergency Medical Technology with practical training, real-world exposure, on-the-job learning and experienced faculty. The programme focuses on skill development, preparing students to become job-ready emergency medical technicians from day one.",

            },
            {
                "id": 9,
                "Question": "Is this course UGC recognised?",
                "Answer": "Yes",

            },
            {
                "id": 10,
                "Question": "Can you enroll in this Diploma in Emergency Medical Technology with a scholarship?",
                "Answer": "Yes. Talk to our counselors to know more.",

            },
            {
                "id": 11,
                "Question": "What is the admission procedure?",
                "Answer": "Call +91 98748 75876 for a detailed admission procedure. You can also refer to the link https://www.msu.edu.in/admission-process",

            },
        ]
    },
    coursePrice: { price: "₹3,75,000" }

};